import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { PageTitleService } from '@tablesready/common-ui';
import { AuthStatesEnum } from './constants';
import { Subscription } from 'rxjs';
import { AlertsService, IAlertTypes } from '@tablesready/frontend-alerts-bar';

@Component({
  selector: 'tablesready-root',
  styleUrls: ['./auth.component.scss'],
  templateUrl: './auth.component.html',
})
export class AuthComponent implements OnInit, OnDestroy {
  state: string;
  loginStates = AuthStatesEnum;
  planCode: string;
  private subscriptions = new Subscription();

  constructor(
    private readonly pageTitleService: PageTitleService,
    private readonly route: ActivatedRoute,
    private readonly alertService: AlertsService,
  ) {
  }

  ngOnInit(): void {
    const queryParamSubscription = this.route.queryParamMap
      .subscribe((params) => {
        this.planCode = params.get('plan');

        this.toggleState(params.keys.includes('signup') && params.get('signup') !== 'false' ? AuthStatesEnum.signup : AuthStatesEnum.login);
        this.checkAlerts(params);
      });
    this.subscriptions.add(queryParamSubscription);
  }

  toggleState(state: AuthStatesEnum): void {
    this.state = state;

    let canonicalUrl = null;
    let title = 'Login';

    if (state === AuthStatesEnum.signup) {
      title = 'Signup';
      canonicalUrl = '/login?signup=';
    }

    this.pageTitleService.setTitle(title, canonicalUrl);
  }

  checkAlerts(params) {

    if (!params || !params.params || Object.keys(params.params).length === 0) {
      return;
    }

    if (params.params.logout === 'true') {
      this.alertService.add({

        type: IAlertTypes.success,
        heading: 'Success: ',
        body: 'Logged out.',
      });
    }

    if (params.params.pwReset === 'true') {
      this.alertService.add({

        type: IAlertTypes.success,
        heading: 'Success: ',
        body: 'Your username and password has been emailed to you.',
      });
    }

    if (params.params.verify === 'success') {
      this.alertService.add({

        type: IAlertTypes.success,
        heading: 'Success: ',
        body: 'Validated your email. Please log in.',
      });
    }

    if (params.params.verify === 'no_user') {
      this.alertService.add({

        type: IAlertTypes.danger,
        heading: 'Error: ',
        body: 'Unable to find user to verify. Please try logging in to continue.',
      });
    }

    if (params.params.verify === 'already_verified') {
      this.alertService.add({

        type: IAlertTypes.warning,
        heading: 'Already verified: ',
        body: 'Please try logging in.',
      });
    }

    if (params.params.verify === 'no_token') {
      this.alertService.add({

        type: IAlertTypes.danger,
        heading: 'Error: ',
        body: 'Your verification token has expired. Please log in to re-send your token.',
      });
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
